import { render, staticRenderFns } from "./HandOff.vue?vue&type=template&id=7f8c022f&scoped=true"
import script from "./HandOff.vue?vue&type=script&lang=js"
export * from "./HandOff.vue?vue&type=script&lang=js"
import style0 from "./HandOff.vue?vue&type=style&index=0&id=7f8c022f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c022f",
  null
  
)

export default component.exports